import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { take } from 'rxjs';
import { DeviceService } from './device.service';

@Injectable({
  providedIn: 'root',
})
export class BodyScrollLockService {
  private readonly document = inject(DOCUMENT);
  private readonly platform = inject(PLATFORM_ID);
  private readonly deviceService = inject(DeviceService);

  private scrollY: number | null = null;
  private isLockApplied = false;

  lock(): void {
    this.deviceService.isMobileSmDown$.pipe(take(1)).subscribe((isMobile) => {
      if (isMobile && !this.isLockApplied) this.applyLock();
    });
  }

  unlock(): void {
    this.removeLock();
  }

  private applyLock(): void {
    const win = this.document.defaultView;
    if (!isPlatformBrowser(this.platform) || !this.document.body || !win) return;

    this.isLockApplied = true;
    this.scrollY = win.scrollY;
    this.document.body.style.position = 'fixed';
    this.document.body.style.top = `-${this.scrollY}px`;
    this.document.body.style.left = '0';
    this.document.body.style.right = '0';
    this.document.body.style.width = '100%';
    this.document.body.style.overflow = 'hidden';
  }

  private removeLock(): void {
    if (!this.isLockApplied) return;

    const win = this.document.defaultView;
    if (!isPlatformBrowser(this.platform) || !this.document.body || !win || this.scrollY === null) return;

    this.isLockApplied = false;
    this.document.body.style.position = '';
    this.document.body.style.top = '';
    this.document.body.style.left = '';
    this.document.body.style.right = '';
    this.document.body.style.width = '';
    this.document.body.style.overflow = '';
    win.scrollTo(0, this.scrollY);
    this.scrollY = null;
  }
}
